import { render, staticRenderFns } from "./RoomBrandingSettings.vue?vue&type=template&id=1f702e2c&scoped=true&"
import script from "./RoomBrandingSettings.vue?vue&type=script&lang=js&"
export * from "./RoomBrandingSettings.vue?vue&type=script&lang=js&"
import style0 from "./RoomBrandingSettings.vue?vue&type=style&index=0&id=1f702e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f702e2c",
  null
  
)

export default component.exports